/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ eventIndex: NonNullable<unknown> }} Event_Transcript_Aria_LabelInputs */

const en_event_transcript_aria_label = /** @type {(inputs: Event_Transcript_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Transcript Event ${i?.eventIndex}`)
};

const fr_event_transcript_aria_label = /** @type {(inputs: Event_Transcript_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Evenement de transcription ${i?.eventIndex}`)
};

const de_event_transcript_aria_label = /** @type {(inputs: Event_Transcript_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Transkript Ereignis ${i?.eventIndex}`)
};

const it_event_transcript_aria_label = /** @type {(inputs: Event_Transcript_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Trascrizione evento ${i?.eventIndex}`)
};

const ru_event_transcript_aria_label = /** @type {(inputs: Event_Transcript_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Транскрипт события ${i?.eventIndex}`)
};

const es_event_transcript_aria_label = /** @type {(inputs: Event_Transcript_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Transcripción del evento ${i?.eventIndex}`)
};

const zh_cn2_event_transcript_aria_label = /** @type {(inputs: Event_Transcript_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`事件记录 ${i?.eventIndex}`)
};

const ja_event_transcript_aria_label = /** @type {(inputs: Event_Transcript_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`トランスクリプトイベント ${i?.eventIndex}`)
};

const hi_event_transcript_aria_label = /** @type {(inputs: Event_Transcript_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ट्रांसक्रिप्ट इवेंट ${i?.eventIndex}`)
};

const pt_pt2_event_transcript_aria_label = /** @type {(inputs: Event_Transcript_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Transcrição do evento ${i?.eventIndex}`)
};

/**
* | output |
* | --- |
* | "Transcript Event {eventIndex}" |
*
* @param {Event_Transcript_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_transcript_aria_label = /** @type {((inputs: Event_Transcript_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Transcript_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_transcript_aria_label(inputs)
	if (locale === "de") return de_event_transcript_aria_label(inputs)
	if (locale === "it") return it_event_transcript_aria_label(inputs)
	if (locale === "ru") return ru_event_transcript_aria_label(inputs)
	if (locale === "es") return es_event_transcript_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_event_transcript_aria_label(inputs)
	if (locale === "ja") return ja_event_transcript_aria_label(inputs)
	if (locale === "hi") return hi_event_transcript_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_event_transcript_aria_label(inputs)
	return en_event_transcript_aria_label(inputs)
});